import React from "react";

function EmptyAssignment() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#fdb440"
        fillRule="evenodd"
        d="M86.762 21.026h338.476c22.954 0 41.762 18.777 41.762 41.73v407.486C467 493.194 448.193 512 425.238 512H86.762C63.778 512 45 493.194 45 470.241V62.755c0-22.953 18.778-41.729 41.762-41.729z"
        clipRule="evenodd"
        data-original="#fdb440"
      ></path>
      <path
        fill="#edf3f4"
        fillRule="evenodd"
        d="M98.852 72.713h314.266c3.388 0 6.133 2.745 6.133 6.103v376.736c0 3.358-2.745 6.103-6.133 6.103H98.852c-3.358 0-6.104-2.745-6.104-6.103V78.816c.001-3.358 2.746-6.103 6.104-6.103z"
        clipRule="evenodd"
        data-original="#edf3f4"
      ></path>
      <path
        fill="#d7e7ec"
        fillRule="evenodd"
        d="M383.126 78.816v376.736c0 3.358-2.745 6.103-6.133 6.103h36.126c3.388 0 6.133-2.745 6.133-6.103V78.816c0-3.358-2.745-6.103-6.133-6.103h-36.126c3.387 0 6.133 2.745 6.133 6.103z"
        clipRule="evenodd"
        data-original="#d7e7ec"
      ></path>
      <path
        fill="#9aafb7"
        d="M327.112 112.971H184.859c-19.394 0-35.172-15.78-35.172-35.176v-56.77a7.722 7.722 0 017.72-7.726h197.187a7.723 7.723 0 017.72 7.726v56.77c-.001 19.396-15.792 35.176-35.202 35.176zM165.126 28.752v49.043c0 10.875 8.852 19.723 19.733 19.723h142.253c10.897 0 19.762-8.848 19.762-19.723V28.752z"
        data-original="#9aafb7"
      ></path>
      <path
        fill="#b5c4cf"
        fillRule="evenodd"
        d="M207.171 0c-11.565 0-21.027 9.461-21.027 21.026 0 11.564 9.462 20.996 21.027 20.996h99.09c11.565 0 21.027-9.432 21.027-20.996C327.287 9.461 317.825 0 306.26 0z"
        clipRule="evenodd"
        data-original="#b5c4cf"
      ></path>
      <path
        fill="#9aafb7"
        fillRule="evenodd"
        d="M186.144 21.026c0 11.564 9.462 20.996 21.027 20.996h99.09c11.565 0 21.027-9.432 21.027-20.996z"
        clipRule="evenodd"
        data-original="#9aafb7"
      ></path>
      <path
        fill="#fe9900"
        fillRule="evenodd"
        d="M419.134 62.755v14.951c.088.35.117.73.117 1.11v376.736c0 .38-.029.759-.117 1.11v13.579c0 22.953-18.778 41.759-41.762 41.759h47.866C448.193 512 467 493.194 467 470.241V62.755c0-22.953-18.807-41.73-41.762-41.73h-47.866c22.984.001 41.762 18.777 41.762 41.73z"
        clipRule="evenodd"
        data-original="#fe9900"
      ></path>
    </svg>
  );
}

export default EmptyAssignment;
